import { createSlice } from '@reduxjs/toolkit'
import { logoutUser } from '../middlewares/logoutMiddleware'
import LocalStorageService from '../../services/local-storage.service'

export const DEFAULT_SUBMISSION_VERSION = 'Latest'

const initialState = {
    selectedVersionId: DEFAULT_SUBMISSION_VERSION,
    selectedSubmissionIds: [],
    openedSubmissionId: null,
    groupsAtSubmissionOpenMoment: null,
}

const submissionSlice = createSlice({
    name: 'submission',
    initialState,
    reducers: {
        setSelectedVersionId: (state, action) => {
            state.selectedVersionId = action.payload
        },
        addSelectedSubmissionId: (state, action) => {
            state.selectedSubmissionIds.push(action.payload)
        },
        removeSelectedSubmissionId: (state, action) => {
            state.selectedSubmissionIds = state.selectedSubmissionIds.filter(id => id !== action.payload)
        },
        addManySelectedSubmissionIds: (state, action) => {
            state.selectedSubmissionIds = [...new Set([...state.selectedSubmissionIds, ...action.payload])]
        },
        removeManySelectedSubmissionIds: (state, action) => {
            state.selectedSubmissionIds = state.selectedSubmissionIds.filter(id => !action.payload.includes(id))
        },
        setSelectedSubmissionIds: (state, action) => {
            state.selectedSubmissionIds = action.payload
        },
        resetSelectedSubmissionIds: state => {
            state.selectedSubmissionIds = []
        },
        openSubmission: (state, action) => {
            state.openedSubmissionId = action.payload.id
            LocalStorageService.setSiderCollapsed(true)
            if (action.payload.groups) state.groupsAtSubmissionOpenMoment = action.payload.groups
            // Persist last visited submission per assignment version if context provided
            if (action.payload.token && action.payload.versionId) {
                LocalStorageService.updateLastVisitedReviewContext(
                    action.payload.token,
                    action.payload.versionId,
                    { submissionId: action.payload.id, questionId: action.payload.questionId },
                )
            }
        },
        closeSubmission: state => {
            state.openedSubmissionId = null
            state.groupsAtSubmissionOpenMoment = null
        },
        reset: () => initialState,
    },
    extraReducers: builder => builder.addCase(logoutUser, () => initialState),
})

export const submissionActions = submissionSlice.actions

export default submissionSlice.reducer
